/* eslint-disable */
export default function _import (file, viewPath = 'page') {
  if (process.env.NODE_ENV === 'development') {
    return require(`@/${viewPath}/${file}.vue`).default
  } else if (process.env.NODE_ENV === 'production') {
    return () => import(`@/${viewPath}/${file}.vue`)
  }
}



// WEBPACK FOOTER //
// ./src/js/import.js